module.exports = __webpack_public_path__ + "img/huaweicce-black.39ee46f2.svg";